<template>
  <el-dialog v-model="dialogVisible" title="栏目参照" @opened="opened" width="70%" top="5vh">
    <div class="list">
      <div class="list-filter">
        <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
          <el-form-item label="文章标题">
            <el-input style="width:600px" size="medium" v-model="queryEntity.title" placeholder="文章标题" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
            <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-container>
        <el-aside class="list-tree" width="200px" style="height:600px">
          <el-tree node-key="id" :data="treeData" :props="defaultProps" @node-click="handleNodeClick" :default-expanded-keys="expandedKeys" />
        </el-aside>
        <el-main style="padding:0 0 0 20px">
          <div class="list-table">
            <el-table ref="tableRefer" :data="dataList" @current-change="changeCurrentRow" :header-cell-class-name="headerCellClass" :max-height="540" border highlight-current-row size="medium" @sort-change='sortChange' :default-sort="{ prop: 'sortNo', order: 'descending' }">
              <el-table-column prop="no" label="序号" width="50" fixed> </el-table-column>
              <el-table-column prop="id" label="ID" width="100"> </el-table-column>
              <el-table-column prop="title" label="标题"> </el-table-column>
              <el-table-column prop="code" label="编号" width="240"> </el-table-column>
              <el-table-column prop="category.name" label="所属栏目" width="180"> </el-table-column>
              <el-table-column prop="stateName" label="状态" width="100"> </el-table-column>
              <el-table-column prop="releaseDate" label="发布时间" width="200"> </el-table-column>
            </el-table>
          </div>
          <div class="list-pager">
            <el-pagination class="list-pager-inner" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" v-model:currentPage="queryParam.pager.pageIndex" v-model:page-size="queryParam.pager.pageSize" :total="queryParam.pager.total" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
          </div>
        </el-main>
      </el-container>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button ref="btnConfirm" type="primary" @click="confirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import {
  Category,
  Content,
  NodeItem,
} from "@/script/apps/cms/entity/CmsEntity";

import { ElMessage } from "element-plus";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { MenuData } from "@/script/core/base/MenuData";
import bus from "@/script/core/util/Bus";
import { CallBack } from "@/script/core/service/DataService";

@Options({})
export default class ContentRefer extends BaseList {
  private categoryList: Category[] | null = null;

  private treeData: NodeItem[] = [];

  private expandedKeys: number[] = [1];

  private selectedId: number | null = null;

  private categoryIds = "";

  private dialogVisible = false;

  private callBack: CallBack<Content> | null = null;

  private currentRow: Content | null = null;

  defaultProps = {
    children: "children",
    label: "label",
  };

  private queryEntity: Content = {};

  private dataList: Content[] = [];

  private service = new ContentService();

  activated() {
    const categoryService = new CategoryService();
    categoryService.loadParentCategorys(0, (data: any) => {
      this.categoryList = data as Category[];

      const parentNodes: NodeItem[] = [];
      this.categoryList.forEach((item) => {
        if (item.parentId == null) {
          const parentNode: NodeItem = new NodeItem();
          parentNode.id = Number(item.id);
          parentNode.label = String(item.name);
          this.getChilds(this.categoryList!, parentNode);
          parentNodes.push(parentNode);
        }
      });
      this.treeData = parentNodes;
    });
  }

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      sorters: [
        { prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" },
        { prop: "id", sortField: "cc.id", sortMode: "desc" },
      ],
    };
    return ServiceFactory.build(
      "biz_cms_content",
      "/cms/content",
      "/cms/content",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      title: "",
    };
    return this.queryEntity;
  }

  private getChilds(dataList: Category[], node: NodeItem) {
    const childNodes: NodeItem[] = [];
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        childNode.id = Number(item.id);
        childNode.label = String(item.name);
        childNodes.push(childNode);

        this.getChilds(dataList, childNode);
      }
    });
    node.children = childNodes;
  }

  private getChildIds(dataList: Category[], node: NodeItem, ids: number[]) {
    dataList.forEach((item) => {
      if (item.parentId === node.id) {
        const childNode: NodeItem = new NodeItem();
        ids.push(item.id!);
        this.getChildIds(dataList, childNode, ids);
      }
    });
  }

  public afterLoadList(data: any): void {
    const currDataList: Content[] = data.list as Content[];
    currDataList.forEach((item) => {});
    this.dataList = currDataList;
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  handleNodeClick(data: any) {
    this.selectedId = data.id;
    this.queryParam.extendMap = {};
    const ids: number[] = [data.id];
    this.getChildIds(this.categoryList!, data, ids);
    this.queryParam.extendMap.categoryIds = ids.join(",");
    this.categoryIds = this.queryParam.extendMap.categoryIds;
    this.loadList();
  }

  changeCurrentRow(row: Category) {
    this.currentRow = row;
  }

  public show(callBack: CallBack<Category>) {
    this.currentRow = null;
    this.callBack = callBack;
    this.dialogVisible = true;
  }

  private opened() {
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  confirm() {
    if (this.currentRow === null) {
      ElMessage.error("请选择文章！");
      return;
    }
    this.dialogVisible = false;
    if (this.callBack) {
      this.callBack(this.currentRow!);
    }
  }
}
</script>
